import * as Yup from 'yup'

export const validationSchemaForm = () =>
    Yup.object({
    fechaOcurrencia: Yup.date().required('El campo es obligatorio.'),
    tipoEvento: Yup.string().required('El campo es obligatorio.')
})